import { render, staticRenderFns } from "./AsDDLs.vue?vue&type=template&id=16d0c15c&scoped=true&"
import script from "./AsDDLs.vue?vue&type=script&lang=js&"
export * from "./AsDDLs.vue?vue&type=script&lang=js&"
import style0 from "./AsDDLs.vue?vue&type=style&index=0&id=16d0c15c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d0c15c",
  null
  
)

export default component.exports